import { UI_CONFIG } from "../config/ui";
import { getHostContext } from "./hostContext";

import lightUrl from "./themes/light.css?url";
import slateUrl from "./themes/slate.css?url";
import nordUrl from "./themes/nord.css?url";

export type ThemeName = "light" | "slate" | "nord";

const THEME_LINK_ID = getHostContext().themeLinkId;

function themeUrl(theme: ThemeName): string {
  if (theme === "slate") return slateUrl;
  if (theme === "nord") return nordUrl;
  return lightUrl;
}

function ensureThemeLink(): HTMLLinkElement {
  const head = document.head ?? document.getElementsByTagName("head")[0];
  const existing = document.getElementById(THEME_LINK_ID);
  if (existing && existing instanceof HTMLLinkElement) return existing;

  const link = document.createElement("link");
  link.id = THEME_LINK_ID;
  link.rel = "stylesheet";
  head.appendChild(link);
  return link;
}

export function getInitialTheme(): ThemeName {
  const raw = localStorage.getItem(UI_CONFIG.storageKeys.theme);
  if (raw === "light" || raw === "slate" || raw === "nord") return raw;

  // Light-first as requested
  return "light";
}

export function applyTheme(theme: ThemeName, opts?: { persist?: boolean }) {
  // Keep attribute for debugging / future theme-specific selectors
  document.documentElement.setAttribute("data-theme", theme);

  const link = ensureThemeLink();
  const nextHref = themeUrl(theme);
  if (link.href !== nextHref) link.href = nextHref;

  const persist = opts?.persist !== false;
  if (persist) localStorage.setItem(UI_CONFIG.storageKeys.theme, theme);
}
